import React, { ReactElement } from "react";
import { Navigate, RoutesProps } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";

interface AuthGuardProps extends RoutesProps {
  children: ReactElement;
}

const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const { isAuthenticated } = useSelector((state: RootState) => state.auth);

  if (isAuthenticated) {
    return <Navigate to="/" />;
  }

  return children;
};

export default AuthGuard;
